export const industryAds = [
  {
    id: 1,
    title: "Premium Office Space Available",
    category: "Real Estate",
    image: "https://public.readdy.ai/ai/img_res/4388810a22bf832eb3a54b6d83e05c38.jpg",
    company: "Crown Realty Group",
    description: "State-of-the-art office suites in downtown Manhattan. Flexible lease terms, fully furnished options available.",
    cta: "Learn More",
    badge: "Featured",
  },
  {
    id: 2,
    title: "Business Loan — Fast Approval",
    category: "Finance",
    image: "https://readdy.ai/api/search-image?query=business%20finance%20loan%20approval%20handshake%20professional%20office%20clean%20white%20background%20money&width=400&height=250&seq=ad2&orientation=landscape",
    company: "SwiftFund Capital",
    description: "Get up to $500,000 in business funding within 48 hours. Low interest rates, flexible repayment.",
    cta: "Apply Now",
    badge: "Hot",
  },
  {
    id: 3,
    title: "Digital Marketing Services",
    category: "Marketing",
    image: "https://readdy.ai/api/search-image?query=digital%20marketing%20social%20media%20analytics%20dashboard%20colorful%20modern%20professional%20growth%20chart&width=400&height=250&seq=ad3&orientation=landscape",
    company: "BrandBoost Agency",
    description: "Grow your brand with data-driven digital marketing. SEO, PPC, social media management.",
    cta: "Get Quote",
    badge: "New",
  },
  {
    id: 4,
    title: "Cloud Computing Solutions",
    category: "Technology",
    image: "https://readdy.ai/api/search-image?query=cloud%20computing%20server%20technology%20abstract%20modern%20professional%20clean%20data%20center&width=400&height=250&seq=ad4&orientation=landscape",
    company: "NexCloud Systems",
    description: "Scalable cloud infrastructure for businesses of all sizes. 99.9% uptime guaranteed.",
    cta: "Free Trial",
    badge: "Featured",
  },
  {
    id: 5,
    title: "HR Recruitment Software",
    category: "HR Tech",
    image: "https://readdy.ai/api/search-image?query=HR%20software%20recruitment%20dashboard%20interface%20modern%20clean%20professional%20white%20hiring&width=400&height=250&seq=ad5&orientation=landscape",
    company: "TalentFlow Pro",
    description: "Streamline your hiring process with AI-powered recruitment tools. ATS, video interviews, analytics.",
    cta: "Start Free",
    badge: "Popular",
  },
  {
    id: 6,
    title: "Corporate Training Programs",
    category: "Education",
    image: "https://readdy.ai/api/search-image?query=corporate%20training%20workshop%20professional%20team%20learning%20modern%20bright%20office%20seminar&width=400&height=250&seq=ad6&orientation=landscape",
    company: "SkillUp Academy",
    description: "Upskill your workforce with certified training programs. Leadership, tech, and soft skills.",
    cta: "Enroll Now",
    badge: "New",
  },
  {
    id: 7,
    title: "Restaurant Franchise Opportunity",
    category: "Food & Beverage",
    image: "https://readdy.ai/api/search-image?query=restaurant%20franchise%20food%20beverage%20modern%20interior%20bright%20clean%20professional%20dining&width=400&height=250&seq=ad7&orientation=landscape",
    company: "TasteCrown Brands",
    description: "Join our award-winning restaurant franchise. Full training, marketing support, and proven systems.",
    cta: "Inquire Now",
    badge: "Hot",
  },
  {
    id: 8,
    title: "Import & Export Trade Services",
    category: "Trade",
    image: "https://readdy.ai/api/search-image?query=import%20export%20trade%20shipping%20containers%20port%20logistics%20professional%20modern%20clean%20aerial&width=400&height=250&seq=ad8&orientation=landscape",
    company: "GlobalTrade Crown",
    description: "Connect with verified suppliers and buyers worldwide. Customs clearance, freight forwarding.",
    cta: "Start Trading",
    badge: "Featured",
  },
  {
    id: 9,
    title: "Luxury Car Dealership — 2026 Models",
    category: "Automotive",
    image: "https://readdy.ai/api/search-image?query=luxury%20car%20dealership%20showroom%20modern%20elegant%20professional%20clean%20bright%20interior%20vehicles&width=400&height=250&seq=ad9&orientation=landscape",
    company: "Crown Motors",
    description: "Exclusive deals on 2026 luxury vehicles. 0% financing available. Test drive today.",
    cta: "Book Test Drive",
    badge: "New",
  },
  {
    id: 10,
    title: "E-commerce Store Setup Service",
    category: "E-commerce",
    image: "https://readdy.ai/api/search-image?query=ecommerce%20online%20store%20setup%20service%20professional%20modern%20clean%20laptop%20shopping%20website&width=400&height=250&seq=ad10&orientation=landscape",
    company: "ShopLaunch Pro",
    description: "Launch your online store in 48 hours. Full setup, design, payment integration included.",
    cta: "Launch Now",
    badge: "Popular",
  },
  {
    id: 11,
    title: "Legal Services for Businesses",
    category: "Legal",
    image: "https://readdy.ai/api/search-image?query=legal%20services%20law%20firm%20business%20professional%20office%20clean%20modern%20elegant%20books&width=400&height=250&seq=ad11&orientation=landscape",
    company: "Crown Legal Partners",
    description: "Business registration, contracts, IP protection, and employment law. Free first consultation.",
    cta: "Free Consult",
    badge: "Featured",
  },
  {
    id: 12,
    title: "Accounting & Tax Filing Services",
    category: "Finance",
    image: "https://readdy.ai/api/search-image?query=accounting%20tax%20filing%20service%20professional%20office%20clean%20modern%20calculator%20documents%20finance&width=400&height=250&seq=ad12&orientation=landscape",
    company: "CrownCount CPA",
    description: "Full-service accounting, bookkeeping, and tax preparation for businesses and individuals.",
    cta: "Get Started",
    badge: "Hot",
  },
];

export const featuredAds = [
  {
    id: 1,
    title: "Crown Business Directory 2026",
    subtitle: "List your business and reach 500,000+ monthly visitors",
    image: "https://readdy.ai/api/search-image?query=business%20directory%20listing%20advertisement%20banner%20professional%20gold%20crown%20elegant%20wide%20panoramic&width=800&height=300&seq=fad1&orientation=landscape",
    cta: "Advertise With Us",
  },
  {
    id: 2,
    title: "Franchise Opportunities Available",
    subtitle: "Join 200+ successful franchise partners across North America",
    image: "https://readdy.ai/api/search-image?query=franchise%20business%20opportunity%20success%20professional%20modern%20clean%20white%20background%20wide%20banner&width=800&height=300&seq=fad2&orientation=landscape",
    cta: "Explore Franchises",
  },
];
